import React from "react";
import { Portal } from "../../Portal/Portal";
import styles from "./ConfirmModal.module.css";

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = () => {
    onClose();
  };

  const handleModalClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Portal>
      <div className={styles.backdrop} onClick={handleBackdropClick}>
        <div className={styles.modal} onClick={handleModalClick}>
          <div className={styles.content}>
            <div className={styles.titleWrapper}>
              <div className={styles.title}>{title}</div>
            </div>
          </div>

          <div className={styles.actions}>
            <button className={styles.confirmButton} onClick={handleConfirm}>
              Да, сообщить о неточности
            </button>
          </div>
        </div>
      </div>
    </Portal>
  );
};
